export const state = () => ({
  activeProfile: null
});

export const mutations = {
  SET_ACTIVE_PROFILE(state, profile) {
    state.activeProfile = profile;
  },
  CLEAR_ACTIVE_PROFILE(state) {
    state.activeProfile = null;
  }
};

export const getters = {
  // Check if the active profile is a sub contractor
  isSubcontractor: (state) => {
    return state.activeProfile?.sub_contractor_id != null;
  },

  // Get the sub contractor ID if available
  subContractorId: (state) => {
    return state.activeProfile?.sub_contractor_id ?? null;
  },

  // Get the full active profile
  activeProfile: (state) => state.activeProfile,

  // Get specific profile properties
  companyId: (state) => state.activeProfile?.company_id ?? null,
  profileId: (state) => state.activeProfile?.profile_id ?? null,
  isKeyUser: (state) => state.activeProfile?.is_key_user ?? false
};

export const actions = {
  setActiveProfile({ commit }, profile) {
    commit('SET_ACTIVE_PROFILE', profile);
  },

  clearActiveProfile({ commit }) {
    commit('CLEAR_ACTIVE_PROFILE');
  }
};
